<ng-container [formGroup]="formGroup">
  <mat-form-field
    #materialFormField
    color="accent"
    [appearance]="matFormFieldAppearance">
    <mat-label
      class="form-builder-input-label"
      [ngClass]="inputLabelStyleName"
      >{{ props.labelTranslation?.label | translate }}</mat-label
    >
    <ng-content></ng-content>
    <mat-error
      class="form-builder-input-empty"
      [ngClass]="inputErrorEmptyStyleName"
      *ngIf="isEmpty()">
      {{ props.labelTranslation?.emptyErrorLabel | translate }}
    </mat-error>
    <mat-error
      class="form-builder-input-invalid"
      [ngClass]="inputErrorInvalidStyleName"
      *ngIf="isInvalidPattern()">
      {{ props.labelTranslation?.invalidPatternErrorLabel | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
